/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Cumulative outage accounting for one media source across the run.
 */
export interface OralExamMediaSourceTotal {
  source: string;
  seconds: number;
  count: number;
}
